export default "__VITE_ASSET__Bg58TTl___"